import { render, staticRenderFns } from "./MoneyTransferHistory.vue?vue&type=template&id=47bd462e"
import script from "./MoneyTransferHistory.vue?vue&type=script&lang=js"
export * from "./MoneyTransferHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports